var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Layout',{staticClass:"ivu-layout-container"},[_c('Header',{style:({position: 'fixed', width: '100%', zIndex: '9999'})},[_c('topNav')],1),_c('Layout',{style:({marginTop: '60px'})},[_c('Content',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }